/* unplugin-vue-components disabled */import script from "./dept.vue?vue&type=script&setup=true&lang=ts"
export * from "./dept.vue?vue&type=script&setup=true&lang=ts"

import "./dept.vue?vue&type=style&index=0&id=4db0d68b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4db0d68b"]])

export default __exports__